import { createMachine } from "xstate";
import { tryAgainMigratingMsisdn } from "@nju/data-access-portal-msisdn";

interface IContext {
  orchestratorId: string | undefined;
}
type IEvent =
  | { type: "TRY_AGAIN" }
  | { type: "RETRY_MIGRATION_SUCCESS" }
  | { type: "RETRY_MIGRATION_FAIL" };

export const goToNextNumberMachine = createMachine(
  {
    schema: {
      context: {} as IContext,
      events: {} as IEvent,
    },
    initial: "ready",
    states: {
      ready: {
        on: {
          TRY_AGAIN: {
            target: "tryAgain",
          },
        },
      },
      tryAgain: {
        invoke: {
          src: "retryMigration",
        },
        on: {
          RETRY_MIGRATION_SUCCESS: {
            actions: "redirectToSelectNewOrExistingNumber",
            target: "success",
          },
          RETRY_MIGRATION_FAIL: {
            target: "error",
          },
        },
      },
      success: {
        type: "final",
      },
      error: {
        type: "final",
      },
    },
  },
  {
    services: {
      retryMigration: ({ orchestratorId }) => {
        return async (callback) => {
          if (!orchestratorId) {
            throw new Error("Missing orchestratorId");
          }
          try {
            await tryAgainMigratingMsisdn(orchestratorId);

            return callback({ type: "RETRY_MIGRATION_SUCCESS" });
          } catch {
            return callback({ type: "RETRY_MIGRATION_FAIL" });
          }
        };
      },
    },
  },
);
